import { AnimatedShape, Box } from '@altermaind/web/ui';

export const CardsContentSkeleton = () => {
  return (
    <Box p='xs' flex={1} display='flex' flexDirection='column'>
      <AnimatedShape height={15} width='30%' variant='semiRound' />
      <AnimatedShape height={25} width='60%' variant='semiRound' mt='xxs' />
      <AnimatedShape height={15} width='100%' variant='semiRound' mt='xxs' />
      <AnimatedShape height={15} width='100%' variant='semiRound' mt='xxs' />
      <AnimatedShape height={15} width='60%' variant='semiRound' mt='xxs' />
      <Box display='flex' flexDirection='column' justifyContent='flex-end' flex={1} mt='s'>
        <AnimatedShape height={30} width='30%' variant='semiRound' mt='xxs' />
      </Box>
    </Box>
  );
};
